import React from "react";
import TermsContainer from "../containers/Terms";

const TermsPrivacy: React.FC = () => {
    return <TermsContainer />;
};

export default TermsPrivacy;
